
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-confirmation",
      function () {
        return require("private-next-pages/order-confirmation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-confirmation"])
      });
    }
  